module.exports = __webpack_public_path__ + "img/myguard_about_08.b24f431d.png";